import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { G_BUTTON__add_special_tokens_cancel } from '../_list/_buttons/G_BUTTON__add_special_tokens_cancel';
import { HOOK__get_lora_tags } from '../_list_item/HOOK__ml_asset_lora_get_tags';
import { G_UI_FIELD__token_list_add_embedding } from './G_UI_FIELD__token_list_add_embedding';
import { G_UI_FIELD__token_list_add_lora_tag_block } from './G_UI_FIELD__token_list_add_lora_tag_block';

interface PROPS {
  field: FIELD__list_token;
}

export function G_UI_FIELD__token_list_add_special_tokens({ field }: PROPS) {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__field_to_add_special_tokens } = use_slice_ui(['g_general__field_to_add_special_tokens']);

  let lora_tags = HOOK__get_lora_tags(field.meta.node_id);

  /*
   *
   */
  function render_list_header() {
    if (g_general__field_to_add_special_tokens.is_stub()) return null;

    return (
      <div className="g_sidebar_settings_header_actions">
        <G_BUTTON__add_special_tokens_cancel />
      </div>
    );
  }

  function render_list_lora_tags() {
    let out = [];

    for (let [hash_sha256, tags] of lora_tags) {
      out.push(<G_UI_FIELD__token_list_add_lora_tag_block key={`render_lora_block_${hash_sha256}`} {...{ field, hash_sha256, tags }} />);
    }

    return out;
  }

  if (generation_current.is_stub()) return <></>;
  if (g_general__field_to_add_special_tokens.is_stub()) return null;

  return (
    <>
      <div className="flex flex-col overflow-y-auto">
        {render_list_header()}

        <G_UI_FIELD__token_list_add_embedding {...{ field }} is_positive={true} />
        <G_UI_FIELD__token_list_add_embedding {...{ field }} is_positive={false} />

        {/* LIST */}
        {render_list_lora_tags()}
      </div>
    </>
  );
}
